import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "forceTag", "margin", "color", "weight", "children"];
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { commonBreakpointsValues } from '@lmn/design-tokens/themeTokens/commonBreakpoints';
import { getResponsiveVariantStyles, getNonResponsiveVariantStyles, getAccentVariantStyles } from "../../../themes/kallistoTheme/mixins/Fonts.js";
// Default HTML element mapping
var elementMapping = {
  Display: 'h1',
  DisplayAccent: 'h1',
  Title1: 'h1',
  Title1Accent: 'h1',
  Title2: 'h2',
  Title2Accent: 'h2',
  Title3: 'h3',
  Title4: 'h4',
  Title5: 'h5',
  Title6: 'h6',
  Body: 'p',
  BodySmall: 'p',
  Caption: 'span'
};
export var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'Body' : _ref$variant,
    forceTag = _ref.forceTag,
    marginProp = _ref.margin,
    colorProp = _ref.color,
    weightProp = _ref.weight,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = forceTag || elementMapping[variant];
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    ref: ref,
    as: Component,
    $variant: variant,
    $margin: marginProp,
    $color: colorProp,
    $weight: weightProp
  }, props), children);
});
Text.displayName = 'Text';
var StyledText = /*#__PURE__*/styled.p.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['variant', '$variant', '$margin', '$color', '$weight'].includes(prop);
  }
}).withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-bargkg-0"
})(["margin:0;padding:0;color:", ";", " ", " ", ""], function (_ref2) {
  var theme = _ref2.theme,
    $color = _ref2.$color;
  if (!$color) return theme.kallisto.color.text.static.textPrimary;
  if ($color in theme.kallisto.color.text.static) {
    return theme.kallisto.color.text.static[$color];
  }
  return theme.kallisto.color.text.interactive[$color];
}, function (_ref3) {
  var theme = _ref3.theme,
    $variant = _ref3.$variant;
  // Responsive variants
  if ($variant === 'Display' || $variant === 'Title1' || $variant === 'Title2') {
    return getResponsiveVariantStyles(theme.kallisto, $variant);
  }
  // Accent variants
  if ($variant === 'DisplayAccent' || $variant === 'Title1Accent' || $variant === 'Title2Accent') {
    return getAccentVariantStyles(theme.kallisto, $variant);
  }
  // Non-responsive variants
  return getNonResponsiveVariantStyles(theme.kallisto, $variant);
}, function (_ref4) {
  var theme = _ref4.theme,
    $margin = _ref4.$margin;
  return $margin && theme.kallisto.mixins.margin($margin);
}, function (_ref5) {
  var theme = _ref5.theme,
    $weight = _ref5.$weight;
  return $weight && css(["font-weight:", ";@media (min-width:", "px){font-weight:", ";}"], theme.kallisto.font.weight[$weight], commonBreakpointsValues['breakpoints-s'], theme.kallisto.font.weight[$weight]);
});